module.exports = __webpack_public_path__ + "img/image_005.6ae89184.jpeg";